if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.parentInfoWrapper = this.closest('div.product__info-container');
      this.form = this.querySelector('form');
      this.form.querySelector('[name*=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));     
    }

    /** Section IDs requested with /cart/add.js — single source of truth for add-to-cart */
    static getSectionIds() {
      return [
        'cart-notification-product',
        'cart-notification-heading',
        'cart-notification-links',
        'cart-price-details-section',
        'cart-free-shipping-bar'
      ];
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', ProductForm.getSectionIds().join(','));
      formData.append('sections_url', window.location.pathname);
      
      if (this.parentInfoWrapper) {
        const addons = this.parentInfoWrapper.querySelectorAll('.addons input[type="checkbox"]:checked');
        for (let i = 0; i < addons.length; i++) {
          formData.append('id[]', addons[i].value);
        }
      }
    
      
      config.body = formData;     
      const cartAddUrl = (window.Shopify?.routes?.root || '') + 'cart/add.js';
      fetch(cartAddUrl, config)
        .then(async (response) => {
          let responseData = null;
          try {
            responseData = await response.json();
          } catch (error) {
            responseData = null;
          }

          if (response.status === 429) {
            throw new Error('Too many requests. Please wait a moment and try again.');
          }
          if (!response.ok) {
            const serverErrorMessage = responseData && (responseData.description || responseData.message);
            throw new Error(serverErrorMessage || 'Request failed. Please try again.');
          }
          return responseData;
        })
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }
          window.__LAST_CART_STATE__ = response;
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: response } }));
        })
        .catch((e) => {
          this.handleErrorMessage(e && e.message ? e.message : 'Something went wrong. Please try again.');
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}